<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='13'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-button type="primary" size="mini" round plain @click="Createtask()">创建任务</el-button>
          <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">余额：</em>
          <count-to :start-val="0" :end-val="balance" :duration="2600" :decimals="2" class="card-panel-num" style="color:#f48504;font-weight:bold;font-size:14px;" />
          <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">支出：</em>
          <count-to :start-val="0" :end-val="expenditure" :duration="2600" :decimals="2" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" />
          <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">预支：</em>
          <count-to :start-val="0" :end-val="income" :duration="2600" :decimals="2" class="card-panel-num" style="color:#13ce66;font-weight:bold;font-size:14px;" />
          <el-checkbox v-model="listQuery.buy_type" @change="changeBuyType" style="margin-left:20px;">是否计算产品购买</el-checkbox>
          <el-select v-model="exp_type" clearable placeholder="请选择支出类型" size="small" style="margin-left: 20px;" @change="changeExpType">
            <el-option label="物流费" value="1"></el-option>
            <el-option label="差旅费" value="2"></el-option>
            <el-option label="交通费" value="3"></el-option>
            <el-option label="销售费" value="4"></el-option>
            <el-option label="房屋租赁" value="5"></el-option>
            <el-option label="办公用品" value="6"></el-option>
            <el-option label="其他" value="7"></el-option>
          </el-select>
          <div style="display: inline-block;padding-top:5px;padding-left:255px;">
            <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" v-loading="qyloading" border style="width: 100%">
                  <el-table-column label="明细" align="center" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.title }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="type" label="账单类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.type == 1" style="color:#ff4949">支出</span>
                      <span v-if="scope.row.type == 2" style="color:#13ce66">收入</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="amount" label="金额">
                    <template slot-scope="scope">
                      <span v-if="scope.row.type == 1" style="color:#ff4949">- {{ scope.row.amount }} </span>
                      <span v-if="scope.row.type == 2" style="color:#13ce66">+ {{ scope.row.amount }} </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="exp_type" label="支出类型">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.exp_type == 1">物流费</el-tag>
                      <el-tag v-if="scope.row.exp_type == 2">差旅费</el-tag>
                      <el-tag v-if="scope.row.exp_type == 3">交通费</el-tag>
                      <el-tag v-if="scope.row.exp_type == 4">销售费</el-tag>
                      <el-tag v-if="scope.row.exp_type == 5">房屋租赁</el-tag>
                      <el-tag v-if="scope.row.exp_type == 6">办公用品</el-tag>
                      <el-tag v-if="scope.row.exp_type == 7">其他</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" prop="imgpath" width="150" label="账单截图">
                    <template slot-scope="{row}">
                      <img v-if="row.imgpath" v-real-img="row.imgpath" src="/../../placeholder.jpg" width="80" height="80" preview="0">
                      <span v-else style="color:#C0C4CC">暂无图片</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                  <el-table-column align="center" prop="addtime" label="添加时间" sortable></el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-button v-if="scopes.row.imgpath" type="text" plain size="mini" preview="0" @click="handleClick(scopes.row)">文件预览</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getFinance" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="账单信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <!-- <el-col :span="11">
            <el-switch
              style="display: block"
              v-model="form.type"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="按月付费"
              inactive-text="按年付费">
            </el-switch>
          </el-col> -->
          <el-col :span="11">
            <el-form-item label="账单类型" prop="type">
              <el-radio-group v-model="form.type" size="medium">
                <el-radio border :label="1">支出</el-radio>
                <el-radio border :label="2">收入</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="支出类型" prop="exp_type" v-if="form.type === 1">
              <el-select v-model="form.exp_type" clearable placeholder="请选择支出类型" @change="changeExp_type">
                <el-option label="物流费" value="1"></el-option>
                <el-option label="差旅费" value="2"></el-option>
                <el-option label="交通费" value="3"></el-option>
                <el-option label="销售费" value="4"></el-option>
                <el-option label="房屋租赁" value="5"></el-option>
                <el-option label="办公用品" value="6"></el-option>
                <el-option label="其他" value="7"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="expType === '1' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">运送货物的费用，例：快递、物流、搬运</div>
            <div v-if="expType === '2' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">出差所产生的费用，例：车票、机票、酒店</div>
            <div v-if="expType === '3' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">工作时发生的交通费，例：打车、滴滴等</div>
            <div v-if="expType === '4' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">维护客情关系产生的费用，例：餐饮、礼品、好处费等</div>
            <div v-if="expType === '5' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">用于业务需求产生的租赁费，例：租房、暖</div>
            <div v-if="expType === '6' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">和办公有关的一切费用，例：设备、耗材</div>
            <div v-if="expType === '7' && form.type === 1" style="font-size: 12px;position: absolute;top:75%;left:445px;line-height: 1;color: #ff5000;">因业务需求产生的其他费用</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="企业">
              <el-cascader v-model="form.companyList" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name' }"  style="width: 100%;" placeholder="请选择厂区"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="明细" prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="金额" prop="amount">
              <el-input-number v-model="form.amount" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="时间" required prop="addtime">
              <el-form-item>
                <el-date-picker type="date" placeholder="选择日期" v-model="form.addtime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传文件" prop="img">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1"
              >
                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="4" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFinance()">确 定</el-button>
      </div>
    </el-dialog>
    <el-image-viewer
      v-if="showImagePreview"
      :url-list="srcList"
      hide-on-click-modal
      teleported
      :on-close="closePreview"
      style="z-index: 3000"
    />
    <el-image
      style="width: 0px; height: 0px"
      src="https://serv.nmzp.com/uploads/1/image/20240411/0badc38dd06f82cf94b7b0a100eb4798.jpg"
      :lazy="true"
      ref="preview"
      :preview-src-list="newsrcList"
    >
    </el-image>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/expense'
import { getType, getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import CountTo from 'vue-count-to'

export default {
  name: 'Finance',
  components: { Top, LeftNav, Bottom, Pagination, ElImageViewer, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      showImagePreview: false,
      newsrcList: ['https://serv.nmzp.com/uploads/1/image/20240411/0badc38dd06f82cf94b7b0a100eb4798.jpg', 'https://serv.nmzp.com/uploads/1/image/20240411/36a9cbd089e1ada4c9f38411dd60979d.jpg'],
      qyloading: false,
      srcList: [],
      fileList: [],
      listQuery: {
        buy_type: false,
        limit: 10,
        page: 1,
        order: 'addtime',
        billing_type: 2
      },
      exp_type: '',
      expType: '',
      dialogFormVisible: false,
      locktype: false,
      companyList: [],
      form: {
        companyList: [],
        title: '',
        imgpath: '',
        amount: '',
        type: 1,
        addtime: '',
        remark: '',
        billing_type: 2,
        exp_type: ''
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择账单类型', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        exp_type: [{ required: true, message: '请选择支出类型', trigger: 'blur' }],
        addtime: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      balance: 0,
      expenditure: 0,
      income: 0
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getFinance()
    this.statistics()
    this.getCompanyList()
  },
  methods: {
    Createtask () {
      this.expType = ''
      this.dialogFormVisible = true
      this.form = {
        title: '',
        imgpath: '',
        amount: '',
        type: 1,
        addtime: '',
        remark: '',
        billing_type: 2,
        exp_type: ''
      }
    },
    saveFinance () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            return false
          }
          this.locktype = true
          if (this.form.type === 2) {
            this.form.exp_type = ''
          }
          api.saveFinance(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.listQuery.exp_type = ''
            this.getFinance()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
            this.exp_type = ''
            this.statistics()
          })
        }
      })
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      this.form.companyList = [row.group_list_id, row.company_id, row.plant_id]
      this.fileList = []
      if (row.imgpath) {
        this.fileList = [{ name: row.imgpath, url: row.imgpath }]
      }
    },
    handlesuccess (response, file) {
      if (response.code === 20000) {
        this.form.imgpath = response.message
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6) && isLt2M
    },
    handleClick (row) {
      const thisType = getType(row.imgpath)
      if (thisType === 'image') {
        this.srcList = [row.imgpath]
        this.showImagePreview = true
      } else if (thisType === 'pdf') {
        window.open(row.imgpath, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.imgpath
        window.open(url, '_target')
      }
    },
    // 关闭预览
    closePreview () {
      this.showImagePreview = false
      document.body.style.overflow = 'auto'
    },
    getFinance () {
      this.qyloading = true
      this.listQuery.user_id = this.current_user.id
      api.getFinance(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.total
        this.isLoading = false
        this.qyloading = false
      })
    },
    statistics () {
      api.statistics({ buy_type: this.listQuery.buy_type, exp_type: this.exp_type }).then((res) => {
        if (res.code === 20000) {
          this.balance = res.data.balance
          this.expenditure = res.data.expenditure
          this.income = res.data.income
        }
      })
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.getFinance()
        this.statistics()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    changeBuyType () {
      this.getFinance()
      this.statistics()
    },
    changeExpType () {
      this.listQuery.exp_type = this.exp_type
      this.getFinance()
    },
    changeExp_type () {
      this.expType = this.form.exp_type
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.preview.clickHandler()
      })
    },
    getCompanyList () {
      api.getCompanyList().then(response => {
        this.companyList = response.message
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/finance.vue